_.mixin(module.exports = {
  deepClone: function(object) {
    var clone;
    clone = _.clone(object);
    _.each(clone, function(value, key) {
      if (_.isObject(value)) {
        return clone[key] = _.deepClone(value);
      }
    });
    return clone;
  },
  isBlank: function(obj) {
    if (_.isString(obj)) {
      return !/\S/.test(obj);
    } else {
      return _.isEmpty(obj);
    }
  },
  escapeRegExp: function(str) {
    if (str != null) {
      return String(str).replace(/([-.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
    } else {
      return '';
    }
  }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvY29tbW9uL3VuZGVyc2NvcmVfbWl4aW5zLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9za2ltL3Nscy9jb3JlL2Zyb250ZW5kL2NvbW1vbi91bmRlcnNjb3JlX21peGlucy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsQ0FBQyxDQUFDLEtBQUYsQ0FBUSxNQUFNLENBQUMsT0FBUCxHQUNOO0VBQUEsU0FBQSxFQUFXLFNBQUMsTUFBRDtBQUNULFFBQUE7SUFBQSxLQUFBLEdBQVEsQ0FBQyxDQUFDLEtBQUYsQ0FBUSxNQUFSO0lBQ1IsQ0FBQyxDQUFDLElBQUYsQ0FBTyxLQUFQLEVBQWMsU0FBQyxLQUFELEVBQVEsR0FBUjtNQUNaLElBQUcsQ0FBQyxDQUFDLFFBQUYsQ0FBVyxLQUFYLENBQUg7ZUFDRSxLQUFNLENBQUEsR0FBQSxDQUFOLEdBQWEsQ0FBQyxDQUFDLFNBQUYsQ0FBWSxLQUFaLEVBRGY7O0lBRFksQ0FBZDtXQUdBO0VBTFMsQ0FBWDtFQU9BLE9BQUEsRUFBUyxTQUFDLEdBQUQ7SUFDUCxJQUFHLENBQUMsQ0FBQyxRQUFGLENBQVcsR0FBWCxDQUFIO2FBQ0UsQ0FBSSxJQUFJLENBQUMsSUFBTCxDQUFVLEdBQVYsRUFETjtLQUFBLE1BQUE7YUFHRSxDQUFDLENBQUMsT0FBRixDQUFVLEdBQVYsRUFIRjs7RUFETyxDQVBUO0VBYUEsWUFBQSxFQUFjLFNBQUMsR0FBRDtJQUNaLElBQUcsV0FBSDthQUNFLE1BQUEsQ0FBTyxHQUFQLENBQVcsQ0FBQyxPQUFaLENBQW9CLDZCQUFwQixFQUFtRCxNQUFuRCxFQURGO0tBQUEsTUFBQTthQUdFLEdBSEY7O0VBRFksQ0FiZDtDQURGIn0=
